export enum BulkUpdateField {
  None = 0,
  IsActive = 1,
  IsMadeToOrder = 2,
  StockQuantity = 3,
  Ncm = 4,
  Barcode = 5,
  Weight = 6,
  Height = 7,
  Width = 8,
  Length = 9,
  Price = 10
};
